module.exports = __webpack_public_path__ + "static/img/fish16.5462bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish16.png
// module id = ow82
// module chunks = 0